import React, { Component } from 'react';
import ClientCompleteView from './ClientCompleteView'
import moment from 'moment'
import { url } from '../../../Server/url/GlobalUrl';

class ClientCompleteComponent extends Component {

 state = {
        company_detail : '',
    }
    componentDidMount() {

        console.log('cv-id',localStorage.getItem('cv-id'))
         let id = localStorage.getItem('cv-id')
		fetch((url + "/api/v1/user/company-detail/"+id+'/'), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		          console.log('hello',result)

                          this.setState({user_email: result.email})
                          this.setState({company_detail: result})
		         })
		}





 render() {
        return (
            <ClientCompleteView
                company_detail={this.state.company_detail}
            />
        )
    }

}

export default ClientCompleteComponent;